import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { getLocaleDayNames } from '@angular/common';
import { E5coreUiWorkDiariseBaseComponent } from './e5core-ui-work-diarise-base.component';



@Component({
  selector: 'e5core-ui-work-diarise-material',
  templateUrl: './e5core-ui-work-diarise-material.component.html',
  styleUrls: ['./e5core-ui-work-diarise-material.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class E5coreUiWorkDiariseMaterialComponent extends E5coreUiWorkDiariseBaseComponent {

}
